/**
 *
 * Asynchronously loads the component for OrdersPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
